import { useQuery } from '@tanstack/react-query';
import {
  searchAuwOrderHistory,
  getAuwOrderHistoryDetail,
} from '../services/auwTracingService';
import {
  AuwOrderHistorySearchRequest,
  AuwOrderHistorySearchResponse,
  AuwOrderHistoryDetailResponse,
} from '../models/auwTracing';

export const useAuwOrderHistorySearch = (
  params: AuwOrderHistorySearchRequest,
  enabled: boolean = false
) => {
  const searchQuery = useQuery<AuwOrderHistorySearchResponse[]>({
    queryKey: ['auw-order-history-search', params],
    queryFn: () => searchAuwOrderHistory(params),
    enabled,
    staleTime: 10_000,
    refetchOnWindowFocus: false,
  });

  return { searchQuery };
};

export const useAuwOrderHistoryDetail = (guid?: string) => {
  const detailQuery = useQuery<AuwOrderHistoryDetailResponse>({
    queryKey: ['auw-order-history-detail', guid],
    queryFn: () => getAuwOrderHistoryDetail(guid!),
    enabled: !!guid,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });

  return { detailQuery };
};
